import { render, staticRenderFns } from "./notifications-detail.vue?vue&type=template&id=4c5ef4e9&scoped=true"
import script from "./notifications-detail.vue?vue&type=script&lang=js"
export * from "./notifications-detail.vue?vue&type=script&lang=js"
import style0 from "./notifications-detail.vue?vue&type=style&index=0&id=4c5ef4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ef4e9",
  null
  
)

export default component.exports